module.exports = __webpack_public_path__ + "static/img/3.df2bbad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/17/3.png
// module id = 38Cf
// module chunks = 2